export default [
  {
    name: 'auth/find/id',
    path: '/auth/find/id',
    meta: {
      requireSignin: false,
      ui: {
        newHeader: true,
        header: {
          backButton: true,
          title: '아이디 찾기',
        },
        classes: ['px-0'],
      },
    },
    component() {
      return import('@/pages/auth/find/Id.vue')
    },
  },
  {
    name: 'auth/find/password',
    path: '/auth/find/password',
    meta: {
      requireSignin: false,
    },
    component() {
      return import('@/pages/auth/find/Password.vue')
    },
  },
]
